import { merge } from 'lodash';
import Card from './Card';
import CssBaseline from './CssBaseline';
import Lists from './Lists';
import Paper from './Paper';
import Input from './Input';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import IconButton from './IconButton';
import Autocomplete from './Autocomplete';
import ListItemButton from './ListItemButton';
import TableCell from './TableCell';
import TableSortLabel from './TableSortLabel';
// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
    return merge(
        CssBaseline(theme),
        ListItemButton(theme),
        Card(theme),
        Lists(theme),
        Paper(theme),
        Input(theme),
        Button(theme),
        Tooltip(theme),
        Backdrop(theme),
        Typography(theme),
        IconButton(theme),
        Autocomplete(theme),
        TableCell(theme),
        TableSortLabel(theme)
    );
}
